export default __webpack_public_path__ + "static/media/moreOptions.0fda9430.svg";